export const sum = (values = []) => (values[0] || 0) + (values[1] || 0);

export const sumWithNaN = (values = []) =>
  isNaN(values[0]) && isNaN(values[1])
    ? Number.NaN
    : (values[0] || 0) + (values[1] || 0);
